import React, { useMemo } from 'react';

type Props = {
  width?: string;
};

let id = 0;

function nextID() {
  return id++;
}

const PatternBorder: React.FC<Props> = (props) => {
  const patternID = useMemo(() => `pattern-${nextID()}`, []);

  return (
    <svg width={props.width} height="12px">
      <pattern
        id={patternID}
        x="0"
        y="0"
        width="26"
        height="12"
        patternUnits="userSpaceOnUse"
      >
        <path
          d="M0,2 C6.50037952,2 6.50037952,10 13.000759,10 C19.4996205,10 19.4996205,2 26,2"
          stroke="#000000"
          strokeWidth="3"
          fill="none"
        ></path>
      </pattern>
      <rect x="0.963013" width="100%" height="2" fill="black"/>
    </svg>
    
  );
};

PatternBorder.defaultProps = {
  width: '234px',
};

export default PatternBorder;
